import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { TableCell, TableRow } from "../../base/table/table";
import { cn } from "../../../utils";
import { flexRender } from "@tanstack/react-table";
/** Collapsible group header: grouped value + row count, toggles the group's rows. */ export function DataTableGroupRow({ row, colSpan }) {
    const groupValue = row.groupingColumnId ? row.getGroupingValue(row.groupingColumnId) : "";
    const isExpanded = row.getIsExpanded();
    return /*#__PURE__*/ _jsx(TableRow, {
        className: "bg-muted/40 hover:bg-muted/40",
        children: /*#__PURE__*/ _jsx(TableCell, {
            colSpan: colSpan,
            className: "p-0",
            children: /*#__PURE__*/ _jsxs("button", {
                type: "button",
                onClick: row.getToggleExpandedHandler(),
                className: "flex w-full items-center gap-2 px-4 py-2 text-left text-sm font-medium hover:bg-muted/60",
                children: [
                    isExpanded ? /*#__PURE__*/ _jsx(ChevronDown, {
                        className: "size-4 text-muted-foreground"
                    }) : /*#__PURE__*/ _jsx(ChevronRight, {
                        className: "size-4 text-muted-foreground"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "truncate",
                        children: String(groupValue ?? "")
                    }),
                    /*#__PURE__*/ _jsxs("span", {
                        className: "text-xs text-muted-foreground",
                        children: [
                            "(",
                            row.subRows.length,
                            ")"
                        ]
                    })
                ]
            })
        })
    });
}
/** A data row plus its optional expandable sub-component row. */ export function DataTableDataRow({ row, renderSubComponent, onRowClick, onRowHover }) {
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TableRow, {
                "data-state": row.getIsSelected() && "selected",
                onClick: onRowClick ? ()=>onRowClick(row) : undefined,
                onMouseEnter: onRowHover ? ()=>onRowHover(row) : undefined,
                className: cn(onRowClick && "cursor-pointer"),
                children: row.getVisibleCells().map((cell)=>{
                    const sticky = cell.column.columnDef.meta?.sticky;
                    const fitContent = cell.column.columnDef.meta?.fitContent;
                    return /*#__PURE__*/ _jsx(TableCell, {
                        sticky: sticky,
                        className: cn(fitContent && "w-0 whitespace-nowrap"),
                        style: {
                            maxWidth: cell.column.columnDef.maxSize
                        },
                        children: flexRender(cell.column.columnDef.cell, cell.getContext())
                    }, cell.id);
                })
            }),
            row.getIsExpanded() && renderSubComponent && /*#__PURE__*/ _jsx(TableRow, {
                children: /*#__PURE__*/ _jsx(TableCell, {
                    colSpan: row.getVisibleCells().length,
                    className: "p-0",
                    children: renderSubComponent({
                        row
                    })
                })
            })
        ]
    });
}

//# sourceMappingURL=DataTableRows.js.map